// ServiceOrderHistoryDashboard.jsx - Updated to use API data
import React from "react";
import { DollarSign, Clock, TrendingUp, Wrench } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";

const ServiceOrderHistoryDashboard = ({ summaryData }) => {
  // Helper function to format labor hours from "HH:MM:SS" format

  const statsData = [
    {
      title: "Total Completed SOs",
      count: summaryData?.result?.totalCompletedSos,
      trendSummary: "Successfully completed",
      icon: <Wrench className="h-8 w-8 text-blue-500" />,
      tooltip: "Total number of service orders successfully completed.",
    },
    {
      title: "Average Cost Per SO",
      count: summaryData?.result?.averageCostPerSo,
      trendSummary: "Per service order",
      icon: <DollarSign className="h-8 w-8 text-green-500" />,
      prefix: "$",
      tooltip: "Average cost incurred for completing each service order.",
    },
    {
      title: "PM vs Reactive Ratio",
      count: summaryData?.result?.pmVsCmRatio,
      trendSummary: "Preventive vs Reactive",
      icon: <TrendingUp className="h-8 w-8 text-purple-500" />,
      tooltip:
        "Percentage of preventive maintenance orders compared to reactive (unplanned) orders.",
    },
    {
      title: "Total Labor Hours",
      count: summaryData?.result?.totalLaborHours,
      trendSummary: `Avg ${summaryData?.result?.totalLaborHours} hrs per SO`,
      icon: <Clock className="h-8 w-8 text-orange-500" />,
      suffix: " hrs",
      tooltip: "Total time spent on service orders, averaged per order.",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          trendSummary={stat.trendSummary}
          icon={stat.icon}
          tooltip={stat.tooltip}
        />
      ))}
    </div>
  );
};

export default ServiceOrderHistoryDashboard;
